<template>
  <div :class="[showType == 'smallZone' ? 'mall-hot-zone' : '', 'authorize-con', showType == 'orderZone' ? 'division-authorize' : '']">
    <div v-if="showType == 'orderZone'" class="authorize-con">
      <p class="authorize-enter authorize-icon" @click.stop="goToAuthManage">授权</p>
    </div>
    <template v-if="showType !== 'orderZone'">
      <p
        v-show="hasSubscribe"
        :class="[
          'mall-subscription',
          showType == 'zoneTop' ? 'mall-subscription-ash' : '',
          isSubscribe ? 'succeed-subscription' : 'add-subscription'
        ]"
        @click.stop="subscibeGroupId"
      >
        {{ isSubscribe ? "已订阅" : "订阅" }}
      </p>
      <span v-show="(hasSubscribe && hasAuthEntry) || hasGap" class="authorize-line"></span>
      <p v-show="hasAuthEntry" class="authorize-enter authorize-icon" @click.stop="goToAuthManage">授权</p>
    </template>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex"
import { CLICK } from "@constants/report-dictonary"
export default {
  name: "SubscribeItem",
  props: {
    subscribeId: {
      type: [String, Number]
    },
    groupId: {
      type: [String, Number]
    },
    groupIds: {
      type: [String, undefined]
    },
    bizId: {
      type: [String, Number, undefined]
    },
    bizIds: {
      type: [String, undefined]
    },
    changeSubscribePromp: {
      type: Function
    },
    pfStructure: {
      type: String
    },
    showType: {
      type: String
    },
    hasSubscribe: {
      type: Boolean,
      default: true
    },
    hasAuthEntry: {
      type: Boolean,
      default: false
    },
    hasGap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 是否点击订阅按钮，以免用户多次点击触发多次请求
      isTriggerSubscribe: false
    }
  },
  computed: {
    ...mapState({
      subscribeGroups: state => state.subscribeGroups,
      isUserFollowedOfficalWechatAccount: state => state.user.isUserFollowedOfficalWechatAccount
    }),
    ...mapGetters(["pf"]),
    isSubscribe() {
      if (this.subscribeGroups && this.subscribeGroups.length) {
        return (
          this.subscribeGroups
            .map(group => {
              return parseInt(group.FGroupID)
            })
            .indexOf(parseInt(this.subscribeId)) > -1
        )
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions([
      "getUserSubscribe",
      "setUserFollowedOffcialWechatAccount",
      "updateSubscribeGroups",
      "setTipMsg",
      "setToastMsg",
      "reportUserAction",
      "setLoadingStart",
      "setLoadingEnd"
    ]),
    subscibeGroupId() {
      // 已订阅的需要弹窗确认是否要取消订阅
      if (this.isSubscribe) {
        this.changeSubscribePromp({ promptStatus: true, subscribeId: this.subscribeId, groupId: this.groupId })
      } else {
        // 未订阅的点击进行订阅
        // 请求订阅信息
        if (!this.isTriggerSubscribe) {
          this.subscribeItem(this.subscribeId)
          this.reportUserAction({
            iformat: CLICK.ZONE_CLICK_SUBSCRIBE,
            resultInfo: {
              groupId: this.groupId,
              pfStructure: this.pfStructure
            }
          })
        }
      }
    },
    /**
     * 调用订阅接口订阅业务
     */
    subscribeItem(subscribeId) {
      this.setLoadingStart()
      this.isTriggerSubscribe = true
      return this.getUserSubscribe({
        action: "subscribe",
        groups: subscribeId
      })
        .then(() => {
          this.setLoadingEnd()
          this.isTriggerSubscribe = false
          this.updateSubscribeGroups({
            groupId: subscribeId,
            isDelete: false
          })
          this.setUserFollowedOffcialWechatAccount({ pf: this.pf })
            .then(() => {
              if (!this.isUserFollowedOfficalWechatAccount) {
                this.setTipMsg({})
              } else {
                this.setToastMsg("订阅成功")
              }
            })
            .catch(() => {
              this.setToastMsg("订阅成功")
            })
        })
        .catch(() => {
          this.isTriggerSubscribe = false
          this.setLoadingEnd()
          this.setToastMsg("系统繁忙，请稍后再试")
        })
    },
    goToAuthManage() {
      this.reportUserAction({
        iformat: CLICK.AUTH_ENTRY
      })
      this.$router.push({
        path: "/auth-manage",
        query: {
          bizgroupid: this.groupIds ? this.groupIds : this.groupId,
          bizid: this.bizIds ? this.bizIds : this.bizId
        }
      })
    }
  }
}
</script>
